import React from "react";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  DialogContent,
} from "@mui/material";

const ENTITY_TYPES: { [key: string]: string } = {
  BILL_OF_LADING: "Bill of Lading",
  BL_COMMODITY: "Commodity",
  BL_CONTAINER: "Container",
};
const RemoveDialog = ({
  handleClose,
  handleRemove,
  type,
  title,
  text,
  button,
  back,
}: {
  handleClose: () => void;
  handleRemove: () => void;
  type?: string;
  title?: string;
  text?: string;
  button?: string;
  back?: string;
}) => {
  return (
    <Dialog open={true} onClose={handleClose}>
      <DialogTitle>
        {title ?? `Remove ${ENTITY_TYPES[type ?? ""] || type}`}
      </DialogTitle>
      <DialogContent sx={{ width: "445px" }}>
        {text ??
          `Are you sure you want to remove ${ENTITY_TYPES[type ?? ""] || type}? This action cannot be undone.`}
      </DialogContent>
      <DialogActions sx={{ pb: 2, pr: 2 }}>
        <Button onClick={handleClose} color="primary">
          {back || "Cancel"}
        </Button>
        <Button variant="contained" onClick={handleRemove}>
          {button ?? "Remove"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveDialog;
